import {NgModule}                  from '@angular/core';
import {CommonModule}              from '@angular/common';
import {ApBookingComponent}        from './components/ap-booking.component';
import {ApBookingArchiveComponent} from './components/ap-booking-archive.component';
import {ApDynComponentModule}      from '../ap-dyncomponent/ap-dyncomponent.module';
import {ApBookingRoutes}           from './ap-booking.routes';
import {ApUtilsModule}             from '../ap-utils';
import {ApPermissionModule}        from '../ap-permission/ap-permission.module';

@NgModule({
  declarations: [
    ApBookingComponent,
    ApBookingArchiveComponent
  ],
  exports: [
    ApBookingComponent,
    ApBookingArchiveComponent
  ],
  imports: [
    CommonModule,
    ApDynComponentModule,
    ApBookingRoutes,
    ApUtilsModule,
    ApPermissionModule,
  ]
})
export class ApBookingModule {
}
